import ebookHero from 'marketing-website/media/images/pages/ebook-design-systems/book-01@2x.jpg';
import ebook2 from 'marketing-website/media/images/pages/ebook-design-systems/book-02@2x.png';

const assets = {
  hero: {
    alt: 'Preview of the Ebook: Getting Started with Design Systems',
    src: ebookHero,
    hasShadow: false,
    maxWidth: 556,
  },
  second: {
    alt: 'Getting Started with Design Systems on iPad.',
    src: ebook2,
    hasShadow: false,
    maxWidth: 541,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/ebook-design-systems/assets.js